const ws_base = {
    // ----------- File 1 Ws配置 ----------- 
    // wsHost : "10.10.4.6", // 测试环境 10.10.4.6
    // wsPort : "16666",         // 暂时固定
    wsPath: "/msgws", // 固定



    // ----------- File 2 全局ws业务定义，和服务端同步定义 ----------- 
    BZ_PRJT_TXT_MSG: 1001, // 投影仪即时显示的文字消息业务
    BZ_FTSTORE_ROOM_MGR: 1002, // 方糖门店房间管理业务
    BZ_HOTEL_ZYU_ROOM_MGR: 1003, // 酒店足浴房间管理业务
    BZ_FBS_STORE_ROOM_MGR: 1004, // 加盟商门店房间管理的
    BZ_MCH_WEB_NTF: 1005, // 商户web端消息推送
    BZ_HOTEL_ROOM_MGR: 1008, // 开关房操作
    AGENT_WEB_MSG: 1012, // 投影仪即时显示的文字消息业务

}

export {
    ws_base
}


// WEBPACK FOOTER //
// ./src/http/ws_base.js